export default __webpack_public_path__ + "7539f9fccd260b625e6e2d56f66338f0.png";